import React, { PropTypes } from 'react';
import SuperTreeview from 'react-super-treeview';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';

class CustomSuperTreeview extends SuperTreeview {

	handleLink(id) {
		window.open(`/admin/documents/view/${id}`, "_blank");
	}

	printNodes(nodeArray) {
		const {
			keywordKey,
			keywordLabel,
			depth,
			transitionEnterTimeout,
			transitionExitTimeout,
			getStyleClassCb
		} = this.props;
		const {
			printExpandButton,
			printCheckbox,
			printDeleteButton,
			printChildren
		} = this;

		const nodeTransitionProps = {
			classNames: 'super-treeview-node-transition',
			style: {
				transitionDuration: `${transitionEnterTimeout}ms`
			},
			timeout: {
				enter: transitionEnterTimeout,
				exit: transitionExitTimeout
			}
		};

		return (
			<TransitionGroup>
				{isEmpty(nodeArray)
					? this.printNoChildrenMessage()
					: nodeArray.map((node, index) => {
						const nodeText = get(node, keywordLabel, '');
						let spanButton = "";
						let classHas = "";
						let button = "";
						if (!("children" in node)) {
							if (node.documents !== null) { 
								classHas="hasFile";
								node.documents.map( docu => {
									button=(<i className="fas fa-external-link-alt ftp2-export-button"
									data-tip="Editar documento cadastrado"
									title="Editar documento cadastrado"
									onClick={this.handleLink.bind(this, docu)} />);
								});
							} else {
								classHas="";
								//button=<input type="checkbox" onClick={this.props.handleCheckbox.bind(this, node.path)} />;
							}
							spanButton = (<span data-tip="Download do documento "
							title="Download do documento" 
							className={classHas}
							onClick={() => this.props.downloadFile(node)}>
							{nodeText}
							</span>);
						} else {
							spanButton = (<span data-tip="Download do documento" title="Download do documento" > {nodeText}</span>);
						}
						let spaceBT = "";
						if (typeof (printCheckbox(node, depth)) === "undefined" && typeof (node.children) === "undefined") {
							spaceBT = (<span className="spacebt"> </span>);
						}

						return (
							<CSSTransition
								{...nodeTransitionProps}
								key={node[keywordKey] || index}
							>
								<div
									className={
										'super-treeview-node' +
										getStyleClassCb(node)
									}
								>
									<div className="super-treeview-node-content">
										{printExpandButton(node, depth)}
										{printCheckbox(node, depth)}
										{spaceBT}
										<i className={this.iconfile(node)} />
										<label htmlFor={node.id}
												title={nodeText}
												className="super-treeview-text">
											{spanButton}
											{button}

										</label>

										{printDeleteButton(node, depth)}
									</div>
									{printChildren(node)}
								</div>
							</CSSTransition>
						);
					})}
			</TransitionGroup>
		);
	}

	printChildren(node) {
		if (!node.isExpanded) {
			return null;
		}

		const { keywordChildren, keywordChildrenLoading, depth } = this.props;
		const isChildrenLoading = get(node, keywordChildrenLoading, false);
		let childrenElement;

		if (isChildrenLoading) {
			childrenElement = get(this.props, 'loadingElement');
		} else {
			childrenElement = (
				<CustomSuperTreeview
					{...this.props}
					data={node[keywordChildren] || []}
					depth={depth + 1}
					onUpdateCb={onChildrenUpdateCb.bind(this)}
				/>
			);
		}

		return (
			<div className="super-treeview-children-container">
				{childrenElement}
			</div>
		);

		function onChildrenUpdateCb(updatedData) {
			const data = cloneDeep(this.state.data);
			const currentNode = find(data, node);

			currentNode[keywordChildren] = updatedData;
			
			this.handleUpdate(data);
		}
	}

	iconfile(node) {
		if (node.children != null || node.children === []) {
			if (node.isExpanded) {
				return `far fa-folder-open ftpiconPadding`;
			} else {
				return `far fa-folder ftpiconPadding`;
			}
		} 
		const fext = node.name.split('.').pop().toLowerCase();
		let icon = "";

		switch (fext) {
			case "docx":
				icon = "fa-file-word";
				break;
			case "doc":
				icon = "fa-file-word";
				break;
			case "odt":
				icon = "fa-file-powerpoint";
				break;
			case "txt":
				icon = "fa-file-alt";
				break;
			case "htm":
				icon = "fa-file-code";
				break;
			case "pptx":
				icon = "fa-file-powerpoint";
				break;
			case "ppt":
				icon = "fa-file-powerpoint";
				break;
			case "xls":
				icon = "fa-file-excel";
				break;
			case "xlsx":
				icon = "fa-file-excel";
				break;
			case "xlsm":
				icon = "fa-file-excel";
				break;	
			case "pdf":
				icon = "fa-file-pdf";
				break;
			case "zip":
				icon = "fa-file-archive";
				break;
			case "rar":
				icon = "fa-file-archive";
				break;
			case "m4a":
				icon = "fa-file-audio";
				break;
			case "m4v":
				icon = "fa-file-video";
				break;

			default:
				icon = "fa-file";
				break;
		}

		return `far ${icon} ftpiconPadding`;
	}
}

export default CustomSuperTreeview;
CustomSuperTreeview.propTypes = {
	router: PropTypes.object.isRequired,
	downloadFile: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/FTP/CustomSuperTreeView.js